var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"well",attrs:{"id":"message-home"}},[_c('p',[_vm._v("Manage all your messages on this page. Click/tap an existing message to reply, or start a new chat to message other participants.")]),_c('p',[_vm._v("Click a participant's name in the chat view pane to open their online profile.")])])
}]

export { render, staticRenderFns }